module.exports = __webpack_public_path__ + "static/media/undraw_circles_y7s2.29f4fc4d.png";